import { type ApiResponse } from "apisauce"

import { request } from "../../../services/api.ts"
import type { BaseApiResponse } from "../../../types/api.ts"

const PATH = "/user/automatic-project-creation/"

export interface AutomaticProjectCreationSettings {
  auto_create_project_from_lead: boolean
}

export const getAutomaticProjectCreationSettings = (): Promise<
  ApiResponse<AutomaticProjectCreationSettings>
> => request.api.get(PATH)

// A PATCH response is enveloped by the backend's EnvelopeJSONRenderer
// (`{status, details: {..., data}}`) — the caller reads the saved value back
// on success, so the envelope has to be modeled here (GET above is never
// enveloped).
export const updateAutomaticProjectCreationSettings = (
  payload: AutomaticProjectCreationSettings
): Promise<ApiResponse<BaseApiResponse<AutomaticProjectCreationSettings>>> =>
  request.api.patch(PATH, payload)
